import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t-2 border-grape-soft bg-plum text-white" data-id="element-62" data-mp="3gfsmscqd8umz">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-63" data-mp="3gh3s4gzgmag7">
        <p className="font-display text-xl font-black text-grape-soft" data-id="element-64" data-mp="32m1aiwl92wnk">
          SIGMA SMART<span className="align-super text-xs" data-id="element-65" data-mp="36ppn5toqoifo">™</span>
        </p>

        <p className="mt-3 font-display text-base font-semibold italic text-white/80" data-id="element-66" data-mp="3ug3fzmf5elbb">
          Practical digital tools for more organized professional work.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/75" data-id="element-67" data-mp="3levgx24t5gg6">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-68" data-mp="3qcniknv98gxk">
            <MailIcon className="h-4 w-4 text-grape-soft" data-id="element-69" data-mp="2a1jlnfn4665m" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-70" data-mp="2evxat0b6nh1u">
            <InstagramIcon className="h-4 w-4 text-grape-soft" data-id="element-71" data-mp="3gaz4da2vgxn9" /> @sigmasmart.en
          </a>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-72" data-mp="3v89fgibls1ig">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-73" data-mp="3q8dkf8kvvkf1">Terms &amp; Conditions</a>
          <span data-id="element-74" data-mp="81yyongdi663">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-75" data-mp="817cg38o1ksh">Privacy Policy</a>
          <span data-id="element-76" data-mp="31uqrltj6jrh">·</span>
          <a href="mailto:soporte.sigmasmart@gmail.com" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-77" data-mp="hstrybs1e611">Support</a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/45" data-id="element-78" data-mp="cv1ul28mhrpg">
          © 2026 SIGMA SMART™ — All rights reserved.
        </p>
      </div>
    </footer>;
}